import { useState } from 'react';
import { heroStats } from '@/mocks/nav';

const quickChips = ['官网首页', '最新地址', '打不开', '备用线路'];

export default function Hero() {
  const [keyword, setKeyword] = useState('');

  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20editorial%20magazine%20cover%20background%20with%20layered%20amber%20terracotta%20and%20cream%20paper%20textures%2C%20soft%20film%20grain%2C%20geometric%20arch%20shapes%2C%20elegant%20minimal%20composition%2C%20no%20text%2C%20cinematic%20warm%20lighting&width=1920&height=1200&seq=nav-hero-cover&orientation=landscape"
          alt="51网址导航官网首页入口的大主视觉封面"
          title="51网址导航入口 官网首页一键直达"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75"></div>
      </div>

      <div className="relative w-full max-w-content mx-auto px-4 md:px-10 pt-32 pb-16 md:pt-44 md:pb-24">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-background-50/90 text-xs font-label tracking-wide animate-fade-up">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-400 animate-pulse-soft"></span>
            5 条线路实时检测 · 全部可用
          </span>

          <h1 className="mt-6 font-heading text-3xl md:text-6xl leading-[1.2] md:leading-[1.15] font-bold text-background-50 text-balance animate-fade-up delay-1">
            51网址导航入口
            <br />
            官网首页一键直达
          </h1>

          <p className="mt-6 text-base md:text-lg leading-relaxed text-background-100/90 animate-fade-up delay-2">
            这里提供 51网址导航 的官网首页入口与最新可用地址，专门解决打不开、被拦截等访问问题。无论你是想找旧入口还是换新地址，按页面指引即可快速恢复访问，省去反复搜索的麻烦。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 animate-fade-up delay-3">
            <a
              href="#latest"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 font-label text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-login-box-line"></i>
              一键直达官网首页
            </a>
            <a
              href="#guide"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md border border-background-50/40 text-background-50 font-label text-sm whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              <i className="ri-compass-3-line"></i>
              打不开这样进
            </a>
          </div>
        </div>

        {/* 入口搜索条 */}
        <div className="mt-12 md:mt-16 max-w-2xl animate-fade-up delay-4">
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 p-2 rounded-xl bg-background-50 border border-background-200/60">
            <span className="hidden sm:flex w-10 h-10 items-center justify-center text-foreground-400 text-lg">
              <i className="ri-search-2-line"></i>
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="text"
              name="nav-search"
              placeholder="输入关键词或站点名，快速定位入口"
              className="flex-1 min-w-0 px-3 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 bg-transparent outline-none"
            />
            <button
              type="button"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-foreground-950 text-background-50 font-label text-sm whitespace-nowrap hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-up-line"></i>
              定位入口
            </button>
          </div>
          <div className="mt-3 flex flex-wrap items-center gap-2">
            <span className="text-xs font-label text-background-100/70">热门检索</span>
            {quickChips.map((chip) => (
              <button
                key={chip}
                type="button"
                onClick={() => setKeyword(chip)}
                className="px-3 py-1 rounded-full bg-background-50/12 border border-background-50/25 text-background-50/90 text-xs font-label hover:bg-background-50/20 transition-colors cursor-pointer"
              >
                {chip}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* 数据条 */}
      <div className="relative border-t border-background-50/15">
        <div className="w-full max-w-content mx-auto px-4 md:px-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-background-50/15">
            {heroStats.map((stat) => (
              <div key={stat.label} className="py-5 sm:px-6 first:sm:pl-0">
                <p className="text-xs font-label tracking-wide text-background-100/70">{stat.label}</p>
                <p className="mt-1.5 font-heading text-lg md:text-xl text-background-50">{stat.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}